import { chakra } from '@chakra-ui/react';

const Colgroup = chakra('colgroup');
const Col = chakra('col');

type Props = {
  variant: 'notary' | 'citizen';
};

const variants = {
  notary: (
    <>
      <Col width='225px' display={{ base: 'none', md: 'revert' }} />
      <Col width='150px' display={{ base: 'none', md: 'revert' }} />
    </>
  ),
  citizen: null,
};

const TrashDocumentsTableColGroup = ({ variant }: Props) => (
  <Colgroup>
    <Col width='50px' display={{ base: 'none', md: 'revert' }} />
    <Col width='100%' />
    {variants[variant]}
    <Col width='80px' />
  </Colgroup>
);

export default TrashDocumentsTableColGroup;
